module.exports = __webpack_public_path__ + "img/american_credit_faq_1.8048d36.png";